<template>
  <div class="additional-exhibitor-form">
    <div class="exhibitor-header">
      <h4>{{ t.additional_exhibitor }} #{{ index + 1 }}</h4>
      <button 
        type="button" 
        @click="removeExhibitor" 
        class="remove-button"
        :title="t.remove_exhibitor"
      >
        ×
      </button>
    </div>
    
    <div class="form-fields">
      <div class="form-field">
        <InputText 
          v-model="exhibitorData.companyName" 
          :name="`additional_exhibitor_company_${exhibitorData.id}`" 
          :label="t.exhibitor_companyname" 
          type="text" 
          :min-length="2" 
          :max-length="100" 
          required
          @update:modelValue="updateField('companyName', $event)"
        />
      </div>
      
      <div class="form-field">
        <InputText 
          v-model="exhibitorData.contactPerson" 
          :name="`additional_exhibitor_contact_${exhibitorData.id}`" 
          :label="t.contact_person" 
          type="text" 
          :min-length="2" 
          :max-length="50" 
          required
          @update:modelValue="updateField('contactPerson', $event)"
        />
      </div>
      
      <div class="form-field">
        <InputText 
          v-model="exhibitorData.email" 
          :name="`additional_exhibitor_email_${exhibitorData.id}`" 
          :label="t.contact_email" 
          type="email" 
          :min-length="5" 
          :max-length="254" 
          required
          @update:modelValue="updateField('email', $event)"
        />
      </div>
      
      <div class="form-field">
        <InputText 
          v-model="exhibitorData.phoneNumber" 
          :name="`additional_exhibitor_phone_${exhibitorData.id}`" 
          :label="t.contact_phonenumber" 
          type="text" 
          :min-length="10" 
          :max-length="15" 
          required
          @update:modelValue="updateField('phoneNumber', $event)"
        />
      </div>
      
      <div class="form-field">
        <InputText 
          v-model="exhibitorData.website" 
          :name="`additional_exhibitor_website_${exhibitorData.id}`" 
          :label="t.website" 
          type="text" 
          placeholder="www.website.nl"
          :max-length="200" 
          @update:modelValue="updateField('website', $event)"
        />
        <span class="field_help_text">Voer alleen het domein in (bijvoorbeeld: www.website.nl). Voeg geen http:// of https:// toe.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import InputText from '@/components/shared/FormElements/InputText.vue';
import useTexts from '@/composables/useTexts';

export default {
  name: 'AdditionalExhibitorForm',
  components: {
    InputText
  },
  props: {
    exhibitor: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  emits: ['update', 'remove'],
  setup(props, { emit }) {
    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent('AdditionalExhibitorForm');
    
    const exhibitorData = ref({ ...props.exhibitor });

    const updateField = (field, value) => {
      exhibitorData.value[field] = value;
      emit('update', props.exhibitor.id, field, value);
    };

    const removeExhibitor = () => {
      emit('remove', props.exhibitor.id);
    };

    // Watch for changes in the exhibitor prop
    watch(() => props.exhibitor, (newExhibitor) => {
      exhibitorData.value = { ...newExhibitor };
    }, { deep: true });

    return {
      exhibitorData,
      updateField,
      removeExhibitor,
      t
    };
  }
};
</script>

<style scoped>
.additional-exhibitor-form {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #f9f9f9;
  position: relative;
}

.exhibitor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
}

.exhibitor-header h4 {
  margin: 0;
  color: #333;
  font-size: 1.1em;
}

.remove-button {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.remove-button:hover {
  background: #c82333;
}

.form-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.field_help_text {
  display: block;
  margin-top: 5px;
  font-size: 0.85em;
  color: #666;
  font-style: italic;
}

@media (max-width: 768px) {
  .form-fields {
    grid-template-columns: 1fr;
  }
}
</style>
